export default __webpack_public_path__ + "static/media/NIC.bc98d450.png";